module.exports = __webpack_public_path__ + "img/no.v4.2.3.1769759338255.png";